var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"template-shop"},[_c('v-row',[_c('v-col',{staticClass:"pt-10",attrs:{"offset":"4","md":"4"}},[_vm._v("В процессе разработки...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }